// extracted by mini-css-extract-plugin
export default {"colleagueSaved":"styles_colleagueSaved__Hk8Gq","icon":"styles_icon__ZZzQd"};